/*
 * TSS custom — MW Bundle Builder cross-sell pop-up tweaks (not part of Sleek; re-add after theme updates)
 *
 * The pop-up lives inside the app's own sealed component (<mw-offers-dialog>, shadow DOM), so normal
 * theme CSS can't reach it. This script adds a small stylesheet inside it whenever the pop-up appears.
 *
 * All screen sizes:
 *   - every card has the same layout: photo panel with a fixed shape, 2-line title, price,
 *     year line (space kept even when there's no year), then quantity + button side by side,
 *     pinned to the bottom so the buttons don't jump from card to card
 *   - button reads "Add" (instead of "Add to cart") and is pill-shaped
 * Phones only (under 768px wide):
 *   - neighbouring cards peek in from the screen edges (hints there's more to swipe)
 *
 * If MW changes its pop-up markup in an update, these tweaks simply stop applying — nothing breaks.
 */
(function () {
  if (window.__tssMwPopupTweaks) return;
  window.__tssMwPopupTweaks = true;

  var STYLE_ID = 'tss-mw-popup-tweaks';
  var BUTTON_FROM = 'Add to cart';
  var BUTTON_TO = 'Add';

  var CSS = [
    // Card: photo panel on top, content below, controls pinned to the bottom.
    '.Slide { padding: 0 0 16px !important; display: flex !important; flex-direction: column !important; overflow: hidden !important; text-align: left !important; }',
    '.Slide__SlideImage { aspect-ratio: 6 / 5; height: auto !important; flex: 0 0 auto !important; margin: 0 !important; padding: 0 !important; background: #efefef; overflow: hidden !important; }',
    '.Slide__SlideImage a { display: block !important; width: 100% !important; height: 100% !important; }',
    '.Slide__SlideImage img { width: 100% !important; height: 100% !important; max-width: none !important; max-height: none !important; object-fit: cover !important; }',
    '.Slide__SlideContent { flex: 1 1 auto !important; display: flex !important; flex-direction: column !important; padding: 14px 14px 0 !important; margin: 0 !important; width: auto !important; max-width: none !important; min-width: 0 !important; align-self: stretch !important; box-sizing: border-box !important; }',
    // Title always reserves two lines, price on its own line, so everything lines up card to card.
    '.CrossellSlide__Pricing { display: flex !important; flex-direction: column !important; align-items: flex-start !important; }',
    '.CrossellSlide__Pricing > p:first-child { min-height: 2.6em; margin: 0 !important; }',
    '.CrossellSlide__Pricing > .Slide__Price { margin-top: 4px !important; }',
    // Year line (or an empty line of the same height when there's no year), then quantity + button side by side.
    // If a card is ever too narrow for both, the button drops below the quantity box instead of being cut off.
    '.Slide__SlideContent > .flex-1 { display: flex !important; flex-direction: row !important; flex-wrap: wrap !important; align-items: center !important; justify-content: flex-start !important; gap: 8px 10px; margin-top: auto !important; padding-top: 8px; flex: 0 0 auto !important; }',
    '.Slide__SlideContent > .flex-1 > * { margin: 0 !important; min-width: 0; }',
    '.Slide__SlideContent > .flex-1 > p { flex: 0 0 100%; min-height: 1.4em; }',
    ".Slide__SlideContent > .flex-1:not(:has(> p))::before { content: ''; flex: 0 0 100%; height: 1.4em; }",
    '.Slide__SlideContent > .flex-1 > div:first-of-type { flex: 0 0 auto !important; }',
    '.Slide__SlideContent > .flex-1 > div:last-child { flex: 1 1 56px !important; min-width: 56px !important; }',
    // Slightly more compact quantity selector so the button has room on narrower desktop cards.
    '.QuantityInput__Button { width: 32px !important; min-width: 32px !important; padding: 4px !important; }',
    '.QuantityInput__Control { width: 28px !important; }',
    // Pill-shaped button.
    '.Slide__SlideContent > .flex-1 .Button { width: 100% !important; white-space: nowrap !important; padding-left: 12px !important; padding-right: 12px !important; border-radius: 9999px !important; }',
    // Phones: stretch the slider past the pop-up's 24px side padding so peeking cards run to the screen edge,
    // then narrow the track so the edges of the neighbouring cards show.
    // (The app moves cards by the track's width, so the track - not the cards - must be narrowed.)
    '@media (max-width: 767px) {',
    '  .ProductSlider__Wrapper { overflow: hidden !important; margin-left: -24px !important; margin-right: -24px !important; }',
    '  .ProductSlider--slidesWrapper { width: calc(100% - 72px) !important; margin: 0 auto !important; overflow: visible !important; }',
    '}',
  ].join('\n');

  // Swap the button wording. Only the exact "Add to cart" text is changed, so any other
  // state the app shows (e.g. while adding or when sold out) still comes through.
  function relabel(root) {
    var labels = root.querySelectorAll('.Slide .Button__Text');
    for (var i = 0; i < labels.length; i++) {
      if (labels[i].textContent.trim() === BUTTON_FROM) labels[i].textContent = BUTTON_TO;
    }
  }

  function apply() {
    var hosts = document.querySelectorAll('mw-offers-dialog');
    for (var i = 0; i < hosts.length; i++) {
      var root = hosts[i].shadowRoot;
      if (!root) continue;
      if (!root.getElementById(STYLE_ID)) {
        var style = document.createElement('style');
        style.id = STYLE_ID;
        style.textContent = CSS;
        root.appendChild(style);
      }
      relabel(root);
      // Keep the stylesheet and wording in place whenever the app redraws its pop-up.
      if (!root.__tssWatched) {
        root.__tssWatched = true;
        (function (r) {
          new MutationObserver(function () {
            if (!r.getElementById(STYLE_ID)) apply();
            relabel(r);
          }).observe(r, { childList: true, subtree: true, characterData: true });
        })(root);
      }
    }
  }

  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; apply(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  // The app may attach its shadow root a moment after the element appears; re-check briefly.
  var tries = 0;
  var timer = setInterval(function () { apply(); if (++tries > 20) clearInterval(timer); }, 500);
  apply();
})();
